import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'EmobilityEngineConsumptionAndCo2' })(theme => ({
	root: {
		fontSize: '12px',
		lineHeight: '16px',
		marginTop: '9px',

		'>div': {
			display: 'inline-block',
			'&:not(:last-child)': {
				paddingRight: '7px'
			}
		}
	},
	label: {
	},
	value: {
		paddingLeft: '3px',
		fontWeight: 'bold',
		whiteSpace: 'nowrap'
	}
}));

export type EmobilityEngineConsumptionAndCo2Props = {
	consumption?: {
		label: string;
		value: string;
	};
	co2?: {
		label: string;
		value: string;
	},
	classes?: Partial<ReturnType<typeof useStyles>['classes']>
};

export const EmobilityEngineConsumptionAndCo2: React.FC<EmobilityEngineConsumptionAndCo2Props> = (props) => {
	const { consumption, co2 } = props;
	const { classes: styles } = useStyles(undefined, { props });

	return (
		(consumption || co2) &&
		<div
			data-test='emobility-engine-consumption-co2'
			className={styles.root}>
			{consumption &&
				<div>
					<span data-test='consumption-label' className={styles.label} dangerouslySetInnerHTML={{ __html: consumption.label }} />
					<span data-test='consumption-value' className={styles.value}>{consumption.value}</span>
				</div>}
			{co2 &&
				<div>
					<span data-test='co2-label' className={styles.label} dangerouslySetInnerHTML={{ __html: co2.label }} />
					<span data-test='co2-value' className={styles.value}>{co2.value}</span>
				</div>}
		</div>
	);
};